export const Footer = () => {
return(
<footer>
Frontend Made With <img src="https://img.shields.io/badge/react-%2320232a.svg?style=for-the-badge&logo=react&logoColor=%2361DAFB" alt="REACT"/>
·
Backend Made With  <img src="https://img.shields.io/badge/python-%2320232a.svg?style=for-the-badge&logo=python&logoColor=%2361DAFB" alt="Python"/>
·
Powered by <img src="https://img.shields.io/badge/twitter-%2320232a.svg?style=for-the-badge&logo=twitter&logoColor=%2361DAFB" alt="Twitter"/>
·
Powered by <img src="https://img.shields.io/badge/github-%2320232a.svg?style=for-the-badge&logo=github&logoColor=%2361DAFB" alt="Github"/>
</footer>
);

}